import {
    StrollerAllReviewsPhotosFetchFailureAction,
    StrollerAllReviewsPhotosFetchRequestAction,
    StrollerAllReviewsPhotosFetchSuccessAction,
    StrollerAllReviewsPhotosUpdateThumbsAction,
    STROLLER_ALL_REVIEWS_PHOTOS_FETCH_FAILURE,
    STROLLER_ALL_REVIEWS_PHOTOS_FETCH_REQUEST,
    STROLLER_ALL_REVIEWS_PHOTOS_FETCH_SUCCESS,
    STROLLER_ALL_REVIEWS_PHOTOS_UPDATE_THUMBS,
} from 'mk2/apps/strollers/containers/StrollerAllReviewsPhotos/StrollerAllReviewsPhotos.actions';
import { tupdate } from 'mk2/helpers/types';
import { loadingState, LoadingState } from 'mk2/reducers/loadingState';
import { Reducer } from 'redux';

export interface StrollerAllReviewsPhotosState {
    loadingState: LoadingState;
    strollerId: number | null;
    strollerReviewIds: number[];
}

export const initialStrollerAllReviewsPhotosState = {
    loadingState: LoadingState.INIT,
    strollerId: null,
    strollerReviewIds: [],
};

export interface StrollersAllReviewsPhotosState {
    pages: {
        [strollerSlug: string]: StrollerAllReviewsPhotosState;
    };
    hideThumbnails: boolean;
    thumbsKey: string;
}

export const initialStrollersAllReviewsPhotosState: StrollersAllReviewsPhotosState = {
    pages: {},
    hideThumbnails: null,
    thumbsKey: new Date().toISOString(),
};

declare type StrollerAllReviewsPhotosReducerAction =
    StrollerAllReviewsPhotosFetchRequestAction
    | StrollerAllReviewsPhotosFetchSuccessAction
    | StrollerAllReviewsPhotosFetchFailureAction
    | StrollerAllReviewsPhotosUpdateThumbsAction;

export const strollersAllReviewsPhotosReducer: Reducer<StrollersAllReviewsPhotosState> =
    (state = initialStrollersAllReviewsPhotosState, action: StrollerAllReviewsPhotosReducerAction) =>
{
    switch (action.type) {
        case STROLLER_ALL_REVIEWS_PHOTOS_FETCH_REQUEST:
        case STROLLER_ALL_REVIEWS_PHOTOS_FETCH_FAILURE: {
            const strollerSlug = action.strollerSlug;
            return tupdate(state, {
                pages: tupdate(state.pages, {
                    [strollerSlug]: tupdate(state.pages[strollerSlug] || initialStrollerAllReviewsPhotosState, {
                        loadingState: loadingState(undefined, action),
                    }),
                }),
            });
        }

        case STROLLER_ALL_REVIEWS_PHOTOS_FETCH_SUCCESS: {
            const strollerSlug = action.strollerSlug;
            return tupdate(state, {
                pages: tupdate(state.pages, {
                    [strollerSlug]: tupdate(state.pages[strollerSlug] || initialStrollerAllReviewsPhotosState, {
                        loadingState: loadingState(undefined, action),
                        strollerId: action.response.result.stroller,
                        strollerReviewIds: action.response.result.strollerReviews,
                    }),
                }),
            });
        }

        case STROLLER_ALL_REVIEWS_PHOTOS_UPDATE_THUMBS: {
            return tupdate(state, {
                hideThumbnails: action.hide,
                thumbsKey: new Date().toISOString(),
            });
        }

        default:
            return state;
    }
};
